import React, { Component } from 'react';
import Creatable from 'react-select/creatable';
import '../assets/custom.css';
import Header from "../HomeHeaderComponent/HomeHeader";
import logoIdeasThatWork from "../assets/images/logo_ideasthatwork.png";
import REST from '../Shared/REST';
import DialogBox from "../Shared/DialogBox";
import icon_twitter from "../assets/images/Twitter_Social_Icon.png";
import icon_fackbook from "../assets/images/Facebook_logo.png";

let EduEmail = false;

export default class RequestAccountComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { firstName: '',
            lastName: '',
            jobTitle: '',
            isTeacher: false,
            eMail: '',
            reason: '',
            done:false,
            warning: '',
            errorEmail: '',
            checkEmail:false,
            confirmEmail: '',
            errorConfirmEmail:'',
            emailMatch: false,
            validated: false,
            modalDialog: false,
            responseContent:'',
            isLoading: false,
            schoolOptions: '',
            schoolValue: ''
        };

        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleJobTitleChange = this.handleJobTitleChange.bind(this);
        this.handleTeacher = this.handleTeacher.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleReasonChange = this.handleReasonChange.bind(this);
        this.handleRequestAccount = this.handleRequestAccount.bind(this);
        this.handleEmailConfirmChange = this.handleEmailConfirmChange.bind(this);
        this.handleSchoolChange = this.handleSchoolChange.bind(this);
        this.handleSchoolCreate = this.handleSchoolCreate.bind(this);
    }

    async componentDidMount() {
        await REST.listSchools().then((response) => {
            if (response.success) {
                let data = response.body;
                let schools = [];
                for (let school of data) {
                    schools.push({value: school.id, label: school.name});
                }
                this.setState({schoolOptions: schools});
            } else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    }

    handleSchoolChange = (newValue) => {
        this.setState({ schoolValue: newValue});
    };

    async handleSchoolCreate(inputValue){
        this.setState({ isLoading: true });
        let body = {
            name: inputValue
        };
        await REST.createSchool(body).then((response) => {
            const options = this.state.schoolOptions;
            const newOption = {value: response.body.id, label: inputValue};
            this.setState({
                      isLoading: false,
                      schoolOptions: [...options, newOption],
                      schoolValue: newOption
                  });
        }, (error) => {
            console.log('Fail to create a new school', error.msg);
        });
    };

    validateEmail(email) {
        let re= /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let validateEdu = /^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(edu|edu\.|org|org\.+[a-zA-Z]{2})$/;
        EduEmail = false;
        if (validateEdu.test(email)) {
            re = validateEdu;
            EduEmail = true;
        }
        let emailCheckResult = re.test(email);
        this.setState({checkEmail: emailCheckResult});
        return emailCheckResult;
    }

    validate(){
        let valid = true;
        let fields = this.state;
        if(fields.firstName === '' || fields.lastName === '' || fields.reason === '' || !this.validateEmail(this.state.eMail) || !fields.emailMatch){
            valid = false;
        }
        this.setState({validated: valid});
        return valid;
    }

    handleFirstNameChange(event) {
        this.setState({ firstName: event.target.value.replace(/\s+/g, '') });
        this.validate();
    }

    handleLastNameChange(event) {
        this.setState({ lastName: event.target.value.replace(/\s+/g, '') });
        this.validate();
    }

    handleJobTitleChange(event) {
        this.setState({ jobTitle: event.target.value });
        this.validate();
    }

    handleTeacher(event) {
        if(event.target.value == false){
            this.setState({ isTeacher: false });
        }
        else{
            this.setState({ isTeacher: true });
        }
    }

    handleEmailChange(event) {
        this.setState({eMail: event.target.value});
        if (!this.validateEmail(event.target.value)){
            this.setState({eMail: '', errorEmail: 'validationRed', warning: 'Email address format is invalid' });
        }
        else {
            this.setState({eMail: event.target.value, warning: '', errorEmail: ''});
        }
        this.validate();
    }

    handleEmailConfirmChange(event){
        this.setState({confirmEmail: event.target.value});
        if(this.validateEmail(event.target.value) && this.validateEmail(this.state.eMail)){
            if(event.target.value === this.state.eMail){
                if(EduEmail){
                    this.setState({reason:'Email with Educational .edu account'});
                }
                else{
                    this.setState({reason:''});
                }
                this.setState({confirmEmail: event.target.value, errorEmail: '', errorConfirmEmail: '', warning: '', emailMatch: true});
            }
            else{
                this.setState({confirmEmail: event.target.value, errorEmail: 'validationRed', errorConfirmEmail: 'validationRed', warning: 'Emails Do Not Match!', emailMatch: false });
            }
        }
        else {
            this.setState({confirmEmail: '', errorEmail: 'validationRed', errorConfirmEmail: 'validationRed', warning: 'Email address format is invalid', emailMatch: false });
        }
        this.validate();
    }

    handleReasonChange(event) {
        this.setState({ reason: event.target.value });
        this.validate();
    }

    handleRequestAccount(event) {
        REST.accountRequest(this.state).then((response) => {
            this.setState({
                modalDialog: true,
                responseContent:'You request has been sent. You should receive an email from us within a couple of days. If not, check your Spam/ Junk Mail folder and whitelist AvePM so you can receive our messages. Alternatively, send an email to: sxh12@psu.edu'
            });
            if(EduEmail){
                this.setState({responseContent:'Account request sent. You will receive an email about the account soon. If you do not receive an email from us, please check your \'spam\' folder and whitelist avenue PM so you can receive emails from us.'});
            }
            //setTimeout(()=>{this.setState({modalDialog:false})},7000);
            this.setState({
                done:true
            });
        }).catch((error) => {
            console.log('Error Request Account', error);
            this.setState({
                modalDialog: true,
                responseContent:'You already have an account. Select \'Get User Name\' or \'Reset Password\' from the login screen.'

            });
            //setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
        event.preventDefault()
    }

    render() {
        return (
            <div>
                <Header currentItem = {"RequestAccount"}/>

                <div className="clearfix"></div>

                <div className="section bgGreen">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1>Take your teaching experience to the next level!</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 bgGrey roundCorners">
                                <h2 style={{marginTop:15}}>Request a free account</h2>
                                <p>Please note all inputs are required. Thanks.</p>
                                <form className="formRequestAccount">
                                    <div id={"validWarning"} style={{color:'red'}}>{this.state.warning}</div>
                                    <label htmlFor="inputEmail" className="sr-only">Email Address</label>
                                    <input type="email" id="inputEmail" className={this.state.errorEmail + ' form-control w100'} onBlur={this.handleEmailChange} placeholder="Email Address" required autoFocus />
                                    <label htmlFor="inputConfirmEmail" className="sr-only">Confirm Email Address</label>
                                    <input type="email" id="inputConfirmEmail" className={this.state.errorConfirmEmail + ' form-control w100'} onBlur={this.handleEmailConfirmChange} placeholder="Confirm Email Address" required />
                                    <label htmlFor="inputFirstName" className="sr-only">First Name</label>
                                    <input onChange={this.handleFirstNameChange} type="text" id="inputFirstName" className="form-control w100" placeholder="First Name" required />
                                    <label htmlFor="inputLastName" className="sr-only">Last Name</label>
                                    <input type="text" onChange={this.handleLastNameChange} id="inputLastName" className="form-control w100" placeholder="Last Name" required />
                                    {/*<label htmlFor="inputJobTitle" className="sr-only">Job Title</label>*/}
                                    {/*<input type="text" id="inputJobTitle" onChange={this.handleJobTitleChange} className="form-control w100" placeholder="Job Title" style={{marginBottom:0}} required />*/}
                                    {/*<div className="checkbox">*/}
                                        {/*<label>*/}
                                            {/*<input type="checkbox" onChange={this.handleTeacher} value={this.state.isTeacher} /> Are you a teacher?</label>*/}
                                    {/*</div>*/}
                                    {
                                        !EduEmail && this.state.checkEmail ?
                                        <div><label htmlFor="inputComment" className="sr-only">How will you use this
                                            account?</label>
                                        < textarea onChange={this.handleReasonChange} placeholder="How will you use this account?" className="form-control w100"></textarea>
                                        </div>
                                        : null
                                    }
                                    {
                                        false  ? //EduMail ?
                                        <Creatable
                                            isClearable
                                            isDisabled={this.state.isLoading}
                                            isLoading={this.state.isLoading}
                                            onChange={this.handleSchoolChange}
                                            onCreateOption={this.handleSchoolCreate}
                                            options={this.state.schoolOptions}
                                            placeholder = {"Enter and create your school or select from the dropdown list."}
                                            value={this.state.schoolValue}
                                        /> : null
                                    }

                                    <button disabled={!this.state.validated || this.state.done} onClick={this.handleRequestAccount} className="btn btn-primary btn-block" type="submit" style={{textAlign:'center'}}>Submit</button>
                                </form>
                            </div>
                            <div className="col-md-6">
                            </div>
                        </div>
                        <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                    </div>
                </div>
                <footer>
                    <div className="container">
                        <div className="col-lg-12">
                            <hr/>
                            <p>&copy; <script>new Date().getFullYear()>2010&&document.write(new Date().getFullYear());</script> Designed and developed by researchers at the North Carolina State University and Penn State University. </p>
                        </div>
                    </div>
                </footer>
            </div >
        )
    }
}
